import BaseMixin from '@/mixins/BaseMixin'
import LoginStepDetailMixin from '../mixins/LoginStepDetailMixin'
import { checkPhone, checkPassword } from '@/utils/validate-rules'
import BaseInput from '@/components/common/BaseInput.vue'
import VerificationCode from '@/components/login/VerificationCode.vue'
import handleSaveAndJump from '@/utils/saveLogin.js'
import { getBusinessType } from '@/constant'
import store from '@/store'
export default {
  name: '',
  props: {},
  mixins: [BaseMixin, LoginStepDetailMixin],
  components: { BaseInput, VerificationCode },
  data() {
    return {
      form: {
        phone: '',
      },
      code: 0,
    }
  },

  computed: {
    submitPasswordDisabled() {
      let _disabled = false
      let currentValue = [('phone', 'password')]
      currentValue.forEach((key) => {
        if (!this.form[key]) {
          _disabled = true
        }
      })
      return _disabled
    },
    submitVerificationCodeDisabled() {
      let _disabled = false
      let currentValue = [('phone', 'verification_code')]
      currentValue.forEach((key) => {
        if (!this.form[key]) {
          _disabled = true
        }
      })
      return _disabled
    },
    rules() {
      return {
        phone: [
          {
            required: true,
            message: this.$t('login.register.inputPhone'),
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              let reg = /^(?:(?:\+|00)86)?1\d{10}$/
              if (reg.test(value)) {
                try {
                  let { data } = await store.dispatch('CheckUser', {
                    user_name: value,
                  })
                  if (data) {
                    return callback(
                      new Error(this.$t('login.register.notExists'))
                    )
                  } else {
                    return callback()
                  }
                } catch (error) {
                  return callback()
                }
              }
              return callback(
                new Error(
                  // TODO: 手机号码错误提示
                  this.$t('login.register.labelRegisteredPhone')
                )
              )
            },
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('login.email.register.setPassPop'),
          },
          {
            validator: (rule, value, callback) => {
              if (!checkPassword(value)) {
                callback(
                  new Error(this.$t('login.email.register.showPasswordRules'))
                )
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        verification_code: [
          {
            required: true,
            message: this.$t('login.register.labelCode'),
          },
          {
            validator: (rule, value, callback) => {
              if (this.isWrong) {
                callback(
                  new Error(this.$t('login.loginPage.wrongSecurityCode'))
                )
              } else {
                callback()
              }
            },
          },
        ],
      }
    },
  },
  mounted() {},
  methods: {
    initAccount(account) {
      // 如果参数中存在account且符合规则，则自动写入
      if (checkPhone(account)) {
        this.form.phone = account
      } else {
        this.$router.push({
          path: `/login/${this.type}/account`,
          query: {
            ...this.$route.query,
          },
        })
      }
    },
    sendCode() {
      this.$refs['form'].validateField('phone', (vaild) => {
        if (!vaild) {
          this.$refs['verification'].send()
        }
      })
    },
    change(e) {
      console.log(e)
    },
    getAccount() {
      return this.form.phone
    },
    init() {
      this.form.phone = this.$route.params.step
    },
    submit(type) {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          try {
            const { phone, verification_code, password } = this.form
            let data = null
            if (type === 'verificationCode') {
              let params = {
                user_name: phone,
                verification_code,
              }
              if (this.fromGuest) {
                params.gi_guest = this.gi_guest
              }
              if (getBusinessType().isNeedTagedSource) {
                params.source = getBusinessType().unionId
              }
              data = await store.dispatch('userSmsLogin', params)
            } else {
              let params = {
                user_name: phone,
                password,
              }
              if (this.fromGuest) {
                params.gi_guest = this.gi_guest
              }
              if (getBusinessType().isNeedTagedSource) {
                params.source = getBusinessType().unionId
              }
              data = await store.dispatch('userLogin', params)
            }
            //处理登录成功以后的
            if (data.code === 0) {
              this.$message.success(this.$t('login.loginPage.success'))
              handleSaveAndJump(data.data)
              // TODO: 跳转登录页面
            }
          } catch (error) {
            console.log(error, "error")
            if (error.code === 11010) {
              this.isWrong = true
              this.$refs['form'].validateField('verification_code')
            }
          }
        }
      })
    },
    SignInPassword() {},
  },
}
